import { Component, OnInit } from '@angular/core';
import { CoreCustomCardReviewRenderer } from '../../shared/core-custom-card.decorator';
import { CoreReviewCardRendererBaseComponent } from '../../shared/core-review-card-rendere-base.component';

@CoreCustomCardReviewRenderer('standard-card-review-renderer')
@Component({
  selector: 'cu-standard-card-review-renderer',
  templateUrl: './standard-card-review-renderer.component.html',
  standalone: false
})
export class StandardCardReviewRendererComponent extends CoreReviewCardRendererBaseComponent implements OnInit {
  ngOnInit() {}
}
